<template>
  <div class="metrics-table">
    <v-row align="start">
      <v-col>
        <div class="caption grey--text text-uppercase font-weight-black">
          Ingresos totales (Esperados)
        </div>
        <br />
        <div>
          <span class="display-1 font-weight-black">
            {{ formatPrice(totalRevenueOrders) }}
          </span>
          <percentage-increase-or-decrease
            :quantity1="totalRevenueOrders"
            :quantity2="totalRevenueOrdersLastYear"
          ></percentage-increase-or-decrease>
          <br />
          <strong>
            Período anterior: {{ formatPrice(totalRevenueOrdersLastYear) }}
          </strong>
        </div>
      </v-col>
      <v-col>
        <div class="caption grey--text text-uppercase font-weight-black">
          Ingresos totales
        </div>
        <br />
        <div>
          <span class="display-1 font-weight-black">
            {{ formatPrice(totalRevenuePayment) }}
          </span>
          <percentage-increase-or-decrease
            :quantity1="totalRevenuePayment"
            :quantity2="totalRevenuePaymentLastYear"
          ></percentage-increase-or-decrease>
          <br />
          <strong>
            Período anterior: {{ formatPrice(totalRevenuePaymentLastYear) }}
          </strong>
        </div>
      </v-col>
      <v-col>
        <div class="caption grey--text text-uppercase font-weight-black">
          Número de pedidos
        </div>
        <br />
        <div>
          <span class="display-1 font-weight-black">
            {{ totalOrders }}
          </span>
          <percentage-increase-or-decrease
            :quantity1="totalOrders"
            :quantity2="totalOrdersLastYear"
          ></percentage-increase-or-decrease>
          <br />
          <strong> Período anterior: {{ totalOrdersLastYear }} </strong>
        </div>
      </v-col>
    </v-row>
    <br />
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Métrica</th>
            <th class="text-left">
              {{ labelDataset1 }}
            </th>
            <th class="text-left">
              {{ labelDataset2 }}
            </th>
            <th class="text-left">
              <v-icon class="increment-icon">mdi-triangle</v-icon>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left">Ticket medio por cliente</td>
            <td class="text-left">{{ formatPrice(avgTicketClient) }}</td>
            <td class="text-left">
              {{ formatPrice(avgTicketClientLastYear) }}
            </td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="avgTicketClient"
                :quantity2="avgTicketClientLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
          <tr>
            <td class="text-left">Número de clientes</td>
            <td class="text-left">{{ totalClients }}</td>
            <td class="text-left">{{ totalClientsLastYear }}</td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="totalClients"
                :quantity2="totalClientsLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
          <tr>
            <td class="text-left">Media de productos por cliente</td>
            <td class="text-left">{{ addNumberFormat(avgProductsClient) }}</td>
            <td class="text-left">
              {{ addNumberFormat(avgProductsClientLastYear) }}
            </td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="avgProductsClient"
                :quantity2="avgProductsClientLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import PercentageIncreaseOrDecrease from "@/components/admin/dashboard/PercentageIncreaseOrDecrease";
import chartMixin from "@/mixins/dashboard/chartMixin";
export default {
  name: "MetricsTable",
  components: { PercentageIncreaseOrDecrease },
  mixins: [chartMixin],
  props: {
    orders: {
      type: Array,
      default: null
    },
    ordersLastYear: {
      type: Array,
      default: null
    },
    labelDataset1: {
      type: String,
      default: null
    },
    labelDataset2: {
      type: String,
      default: null
    },
    productTypeSelected: {
      type: String,
      default: null
    },
    zClosure: {
      type: Object,
      default: null
    }
  },
  computed: {
    totalRevenueOrders() {
      let total = 0;
      this.orders.forEach(order => {
        if (
          this.productTypeSelected !== null &&
          this.productTypeSelected === "all"
        ) {
          total += order.totalOrdersAmount || 0;
        } else if (
          this.productTypeSelected !== null &&
          this.isDrinkType(this.productTypeSelected)
        ) {
          total += order.drinkAmount;
        } else if (
          this.productTypeSelected !== null &&
          this.isFoodType(this.productTypeSelected)
        ) {
          total += order.foodAmount;
        } else {
          total += order.dessertAmount;
        }
      });

      return total;
    },
    totalRevenueOrdersLastYear() {
      let total = 0;

      this.ordersLastYear.forEach(order => {
        if (
          this.productTypeSelected !== null &&
          this.productTypeSelected === "all"
        ) {
          total += order.totalOrdersAmount || 0;
        } else if (
          this.productTypeSelected !== null &&
          this.isDrinkType(this.productTypeSelected)
        ) {
          total += order.drinkAmount;
        } else if (
          this.productTypeSelected !== null &&
          this.isFoodType(this.productTypeSelected)
        ) {
          total += order.foodAmount;
        } else {
          total += order.dessertAmount;
        }
      });

      return total;
    },
    totalRevenuePayment() {
      return this.orders.reduce((acc, n) => acc + n.totalAmount || 0, 0);
    },
    totalRevenuePaymentLastYear() {
      return this.ordersLastYear.reduce(
        (acc, n) => acc + n.totalAmount || 0,
        0
      );
    },
    totalOrders() {
      let totalOrdersInRange = 0;
      this.orders.forEach(order => {
        if (
          this.productTypeSelected !== null &&
          this.productTypeSelected === "all"
        ) {
          totalOrdersInRange += order.totalOrders;
        } else if (
          this.productTypeSelected !== null &&
          this.isDrinkType(this.productTypeSelected)
        ) {
          totalOrdersInRange += order.drinkCount;
        } else if (
          this.productTypeSelected !== null &&
          this.isFoodType(this.productTypeSelected)
        ) {
          totalOrdersInRange += order.foodCount;
        } else {
          totalOrdersInRange += order.dessertCount;
        }
      });
      return totalOrdersInRange;
    },
    totalOrdersLastYear() {
      let totalOrdersInRange = 0;
      this.ordersLastYear.forEach(order => {
        if (
          this.productTypeSelected !== null &&
          this.productTypeSelected === "all"
        ) {
          totalOrdersInRange += order.totalOrders;
        } else if (
          this.productTypeSelected !== null &&
          this.isDrinkType(this.productTypeSelected)
        ) {
          totalOrdersInRange += order.drinkCount;
        } else if (
          this.productTypeSelected !== null &&
          this.isFoodType(this.productTypeSelected)
        ) {
          totalOrdersInRange += order.foodCount;
        } else {
          totalOrdersInRange += order.dessertCount;
        }
      });
      return totalOrdersInRange;
    },
    avgTicketClient() {
      let customerOrders = this.getCustomers(this.orders);
      let customersGrouped = this.arrayGroupBy(customerOrders, "email");
      let ordersClient = Object.values(customersGrouped);
      let total = 0;
      let result = [];
      ordersClient.forEach((orders, index) => {
        orders.forEach(order => {
          total += order.amount;
        });

        result[index] = total;
        total = 0;
      });

      if (result.length === 0) {
        return 0;
      }

      let sum = result.reduce(function(a, b) {
        return a + b;
      }, 0);

      return sum / result.length;
    },
    avgTicketClientLastYear() {
      let customerOrders = this.getCustomers(this.ordersLastYear);
      let customersGrouped = this.arrayGroupBy(customerOrders, "email");
      let ordersClient = Object.values(customersGrouped);
      let total = 0;
      let result = [];
      ordersClient.forEach((orders, index) => {
        orders.forEach(order => {
          total += order.amount;
        });

        result[index] = total;
        total = 0;
      });

      if (result.length === 0) {
        return 0;
      }

      let sum = result.reduce(function(a, b) {
        return a + b;
      }, 0);

      return sum / result.length;
    },
    totalClients() {
      let customerOrders = this.getCustomers(this.orders);
      let customersGrouped = this.arrayGroupBy(customerOrders, "email");
      return Object.keys(customersGrouped).length;
    },
    totalClientsLastYear() {
      let customerOrders = this.getCustomers(this.ordersLastYear);
      let customersGrouped = this.arrayGroupBy(customerOrders, "email");
      return Object.keys(customersGrouped).length;
    },
    avgProductsClient() {
      let customerOrders = this.getCustomers(this.orders);
      let ordersGrouped = this.arrayGroupBy(customerOrders, "email");
      let ordersClient = Object.values(ordersGrouped);
      let total = 0;
      let result = [];
      ordersClient.forEach((orders, index) => {
        // eslint-disable-next-line no-unused-vars
        orders.forEach(order => {
          total += order.orders;
        });

        result[index] = total;
        total = 0;
      });

      if (result.length === 0) {
        return 0;
      }

      let sum = result.reduce(function(a, b) {
        return a + b;
      }, 0);

      return sum / result.length;
    },
    avgProductsClientLastYear() {
      let customerOrders = this.getCustomers(this.ordersLastYear);
      let ordersGrouped = this.arrayGroupBy(customerOrders, "email");
      let ordersClient = Object.values(ordersGrouped);
      let total = 0;
      let result = [];
      ordersClient.forEach((orders, index) => {
        // eslint-disable-next-line no-unused-vars
        orders.forEach(order => {
          total += order.orders;
        });

        result[index] = total;
        total = 0;
      });

      if (result.length === 0) {
        return 0;
      }

      let sum = result.reduce(function(a, b) {
        return a + b;
      }, 0);

      return sum / result.length;
    }
  },
  methods: {
    getCustomers(orders) {
      let customerOrders = [];
      orders.forEach(orderDate => {
        customerOrders = [...customerOrders, ...orderDate.customers];
      });
      return customerOrders;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
